import useTexts from '../../../../useTexts';
import { StyledLogEvent } from '../style';

function OutOfOffice({ userName, reAssignment }) {
  const { outOfOfficeText, reAssignmentText } = useTexts();
  return <StyledLogEvent>{`${userName} ${outOfOfficeText} ${reAssignmentText} ${reAssignment}`}</StyledLogEvent>;
}

export default OutOfOffice;
